import { secureModeFirmwareVersions } from '../../../../helpers/constants';

export default {
	title: 'settings',
	components: [
		{ title: 'eco_mode', component: 'eco_mode_g2' },
		{
			title: 'enhanced_security',
			component: 'enhanced_security_g2',
			min_ver: secureModeFirmwareVersions,
		},
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'change_ct_type', component: 'change_ct_type' },
		{
			title: 'action_on_power_on',
			component: 'action_on_power_on_g2_emeter',
		},
		{
			title: 'reverse_measurement_direction',
			component: 'reverse_measurement_direction_monophase',
		},
		{
			title: 'channel_from_channel_calibration',
			component: 'channel_from_channel_calibration_g2',
		},
		{ title: 'delete_stored_data', component: 'delete_stored_data_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
